import React, { FunctionComponent, memo } from "react";
import { useIntl } from "react-intl";
import {
  SpaceProps,
  IconButton,
  ButtonProps,
} from "@chakra-ui/react";
import { WarningTwoIcon } from "@chakra-ui/icons";


interface IProps extends SpaceProps, ButtonProps {
  onClick: () => void;
}


const AlarmsIndicator: FunctionComponent<IProps> = memo(function AlarmsIndicator({
  title,
  onClick,
  ...rest
}) {
  const intl = useIntl();

  return (
    <IconButton
      aria-label="Alarms button"
      icon={<WarningTwoIcon />}
      rounded="full"
      colorScheme="red"
      onClick={e => {
        onClick();
        e.stopPropagation();
      }}
      title={intl.formatMessage({
        id: "alarms__indicator__title",
        defaultMessage: "Active alarms",
      })}
      {...rest}
    />
  );
});

export default AlarmsIndicator;
